import { render, staticRenderFns } from "./componentLabels.vue?vue&type=template&id=1c643d88&"
import script from "./componentLabels.vue?vue&type=script&lang=ts&"
export * from "./componentLabels.vue?vue&type=script&lang=ts&"
import style0 from "./componentLabels.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports